import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { ListQuoteVM } from "@assets/types";
import QuoteService from "@services/QuoteService";
import type { RootState } from "@state/store";

export const getQuotes = createAsyncThunk("quotes/getQuotes", () =>
  QuoteService.getQuotes()
);

export interface QuotesState {
  quotes: ListQuoteVM[];
  isLoading: boolean;
}

export const initialQuotesState: QuotesState = {
  quotes: [],
  isLoading: false,
};

export const quotesSlice = createSlice({
  name: "quotes",
  initialState: initialQuotesState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getQuotes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getQuotes.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(
        getQuotes.fulfilled,
        (state, action: PayloadAction<ListQuoteVM[]>) => {
          state.isLoading = false;
          state.quotes = action.payload;
        }
      );
  },
});

export const quotesState = (state: RootState) => state.quotesSlice;

export default quotesSlice.reducer;
